import NavBar from "./Components/NavBar/NavBar";
import Home from "./Pages/Home/Home";
function App() {
  return (
    <div className="App">
     
     <NavBar/>
     <Home/>

    </div>
  );
}

export default App;
